  <!--Loaders-->
  <div *ngIf="!finished && masterService.isOnline==true" class='text-center'>
    <img src="assets/themes/images/primary-loader.gif" width="40"  id="loadmore_post">
  </div>
  
  <!--EOf Loaders-->
  <div *ngIf="showrestrict==true" class="my-5 py-5 text-center">
    <img src="assets/themes/images/restricted-content.svg" class="mb-3" alt="restrict content">
    <p class="paragraph">{{restrictError}}</p>
  </div>

  <div class="cme-detail-container" [ngClass]="{'mb-3': callon==undefined}"
    *ngIf=" cmeStatus == 1 && finished && masterService.isOnline==true && showrestrict==false">
    
    <img (click)="backclicked()"
      *ngIf="callon==undefined"
      [eventTracker]='{"category":mls.googleEventText.cme_details.category,"action":mls.googleEventText.cme_details.key7,"product_type":"8", "product_id":cmeDetailData?.course_id}'
      class="cursor-pointer"
      src="assets/themes/icons/back-arrow.svg" 
      alt="back icon" />
    <div class="mb-2" [ngClass]="cmeDetailData?.cme_type == Cme_Type.MODULE ? 'mt-3' : callon == undefined ? 'bg-white container-shadow mt-3': 'rounded-top-2 mt-1'">
      <div class="position-relative overflow-hidden" [ngClass]="{'px-4 pt-4 pb-2': callon=='modal'}">
        <div *ngIf="bannerMedia && bannerMedia !== undefined" [ngClass]="{'px-4 pt-4': callon==undefined}">
          <div [ngClass]="{'mt-3': callon=='modal'}">
          <app-shaka-basic 
            *ngIf="bannerMedia.file_type === mediaType.VIDEO" 
            [videoSrc]="bannerMedia.file_url" 
            [videoBanner]="bannerMedia.preview_url" 
            shakaStyleCss='shaka-model'>
          </app-shaka-basic>
          </div>
          <img *ngIf="bannerMedia.file_type === mediaType.IMAGE" 
            [src]="bannerMedia.file_url"
            onerror="this.src='assets/themes/icons/banner-placeholder.svg'"
            class="post-pic media-image" 
            alt="Media Image" 
            [ngClass]="{'rounded-corners-18': callon=='modal'}"/>
        </div>
        <img 
          *ngIf="cmeDetailData?.banner_url !== '' && !bannerMedia" 
          src={{cmeDetailData?.banner_url}}
          onerror="this.src='assets/themes/icons/large-image-placeholder.svg'"
          class="w-100 post-pic media-image" 
          [ngClass]="{'rounded-corners-18 mt-3': callon=='modal','rounded-corners-12' : cmeDetailData?.cme_type == Cme_Type.MODULE ,'rounded-top-2' : cmeDetailData?.cme_type != Cme_Type.MODULE }"
          alt="Banner Image" />
        <div class="position-absolute p-2 cme-details-top" [ngClass]="{'w-100': callon=='modal'}">
          <span 
            *ngIf="callon!=undefined" 
            (click)="fcs.closeWebModal()"
            [eventTracker]='{"category":mls.googleEventText.cme_details.category,"action":mls.googleEventText.cme_details.key7,"product_type":"8", "product_id":cmeDetailData?.course_id}'
            class="cursor-pointer" [ngClass]="{'float-right mr-2': callon!=undefined}">
            <img src="assets/themes/icons/cancel.svg" alt="close icon" />
          </span>
        </div>
      </div>
      <div class="cnnction-rqst" [ngClass]="{'btm-border': callon=='modal' && (cmeDetailData?.media.length >= 1 || (descDontshow !=true && cmeDetailDesc !=null))}">
        <div [ngClass]="cmeDetailData?.cme_type == Cme_Type.MODULE ? 'pt-4' : callon=='modal' && (cmeDetailData?.banner_url === '' && !bannerMedia) ? 'px-4': 'px-4 pt-4'">
          <p class="mb-3">
            <span
              *ngIf="cmeDetailData?.total_points?.score > 0
                && cmeDetailData?.total_points?.is_cme_under_progress == 0
                && cmeDetailData?.cme_type !== Cme_Type.QUIZ"
              class="chip large outline icon-position-left score mr-2 mb-2">
              <img src="assets/images/grandround/cme_points.svg" width="15px" /> <span
                *ngIf="cmeDetailData?.total_points?.score > 0"> {{cmeDetailData?.total_points?.score}} </span>
              &nbsp;{{cmeDetailData?.total_points?.point_label}}</span>

            <span
              *ngIf="cmeDetailData?.total_points?.is_cme_under_progress == 1
              && cmeDetailData?.cme_type !== Cme_Type.QUIZ"
              class="chip large outline in-progress mr-2 mb-2">
              {{cmeDetailData?.total_points?.is_cme_under_progress_label}}</span>
            <span
              class="chip large timeline mr-2 mb-2">
              <span class="color-grey-700">
              {{mls.languageText.cme_details.key8}}<span *ngIf="mls?.is_lskey_display==1">(cme_details.key8)</span>
              <span class="time"> 
                {{cmeDetailData?.expiry_date | date}}</span></span>
            </span>
          </p>
          <p class="member-profile-box2" [ngClass]="callon=='modal' ? 'heading-3': 'heading-3'">{{cmeDetailData?.course_name}}</p>
          <div class="mb-3">
            <div *ngIf="cmeDetailData?.cme_type != Cme_Type.MODULE" class="secondary-paragraph white-space-pre-line" [innerHtml]="cmeDetailData?.course_summary"></div>
          </div>
          <p class="secondary-paragraph d-flex flex-wrap mb-3">
            <span
              (click)="getSpecialty(Sl)"
              class="cursor-pointer color-grey-500 mr-2"
              *ngFor="let Sl of cmeDetailData?.speciality;">
              <span *ngIf="cmeDetailData?.speciality !=''">#</span>{{Sl?.speciality_name}}
            </span>
          </p>
          <p class="mb-1 accrd d-flex justify-content-between">
            <span
              class="position-relative">
              <img class="mr-2 post-pic rounded-circle box-size-30 mt-0"
                src="{{cmeDetailData?.accreditated?.accreditation_url}}"
                onerror="this.src='assets/themes/icons/sponsor-placeholder.svg'" />
                <span class="paragraph">
                  <span class="color-grey-700">{{cmeDetailData?.accreditated?.prefix_label +' '}}</span>
                </span>
                <span class="paragraph-bold">
                  <span class="color-grey-700">&nbsp;{{cmeDetailData?.accreditated?.accreditation}}</span>
                </span>
            </span>
            <span *ngIf="cmeDetailData?.cme_type === Cme_Type.QUIZ && cmeDetailData?.quiz_leaderboard_url !== ''">
              
              <a (click)="navigateToLeaderBoard()" class="leaderboard-link mr-2 cursor-pointer paragraph">
                {{mls.languageText.cme_details.key15}}
              </a>
              <span class="custom-tooltip bottom mr-2 cursor-pointer">
                <img src="assets/themes/icons/info-blue-icon.svg" alt="info Icon" width="20" />
                <span class="tooltip-content">{{mls.languageText.cme_details.key16}}</span>
              </span>
            </span>
          </p>
          <div class="separator-line my-3"></div>
        </div>
        <div class="px-4 pb-3">
          <div class="row">
            <div class="pr-sm-0 mb-sm-1 mb-3 product-actions"
            [ngClass]="cmeDetailData?.cme_type == Cme_Type.MODULE ? 'col-lg-6 col-md-6 col-sm-7' : callon=='modal' ? 'col-lg-6 col-md-6 col-sm-7': 'col-lg-4 col-md-4 col-sm-5'">
              <p class="float-left cursor-pointer text-center mr-3"
                [eventTracker]='{"category":mls.googleEventText.cme_details.category,"action":mls.googleEventText.cme_details.key1,"product_type":"8", "product_id":cmeDetailData?.course_id}'
                (click)="productBookmark()">
                <span class="mr-2">
                  <img *ngIf="cme_bookmark_loader==true" 
                    src="assets/themes/images/primary-loader.gif" width="20" alt="loader" />
                  
                  <ng-container *ngIf="cmeDetailData?.is_bookmarked!=1 && cme_bookmark_loader==false">
                    <img src="assets/themes/icons/bookmark.svg" alt="bookmark icon">
                  </ng-container>
                  <ng-container *ngIf="cmeDetailData?.is_bookmarked==1 && cme_bookmark_loader==false">
                    <img src="assets/themes/icons/bookmarked.svg" alt="bookmarked icon" />
                  </ng-container>
                </span>
                <span *ngIf="cmeDetailData?.is_bookmarked!=1" 
                  class="button"><span class="color-grey-700">{{mls.languageText.cme_details.key1}}
                  <span *ngIf="mls?.is_lskey_display==1">(cme_details.key1)</span></span>
                </span>
                <span *ngIf="cmeDetailData?.is_bookmarked==1" 
                  class="button"><span class="color-grey-700">{{mls.languageText.cme_details.key3}}
                  <span *ngIf="mls?.is_lskey_display==1">(cme_details.key3)</span></span>
                </span>
              </p>
              <p class="float-left text-center cursor-pointer" 
                (click)="productShare()"
                [eventTracker]='{"category":mls.googleEventText.cme_details.category,"action":mls.googleEventText.cme_details.key2,"product_type":"8", "product_id":cmeDetailData?.course_id}'>
                <span class="mr-2">
                  <img src="assets/themes/icons/share.svg" alt="share icon" />
                </span>
                <span class="button"><span class="color-grey-700">{{mls.languageText.cme_details.key2}}</span></span>
                <span class="button" 
                  *ngIf="mls?.is_lskey_display==1"><span class="color-grey-700">(cme_details.key2)</span></span>
              </p>
              
              <app-ngb-drop-down [ngClass]="cmeDetailData?.cme_type == Cme_Type.MODULE ? 'd-none': ''"
              [ngbDDL]="ngbDDL" 
              [callingfrom]="'cme detail'"
              (resetNgbDDLRecord)="resetNgbDDLRecord($event)"> </app-ngb-drop-down>
            </div>
            <div class="pt-1 text-sm-right leader-board-actions" 
              [ngClass]="cmeDetailData?.cme_type == Cme_Type.MODULE ? 'col-lg-6 col-md-6 col-sm-7' : callon=='modal' ? 'col-lg-6 col-md-6 col-sm-7': 'col-lg-8 col-md-8 col-sm-7'">

              <app-ngb-drop-down [ngClass]="cmeDetailData?.cme_type != Cme_Type.MODULE ? 'd-none': ''"
              [ngbDDL]="ngbDDL" 
              [callingfrom]="'cme detail'"
              (resetNgbDDLRecord)="resetNgbDDLRecord($event)"> </app-ngb-drop-down>

              <button [ngClass]="cmeDetailData?.cme_type == Cme_Type.MODULE ? 'd-none' : cmeDetailData?.remark != 'passed' && ((cmeDetailData.is_reattempt_allow ===1 && cmeDetailData.attempts.attempted > 0) || (cmeDetailData.is_reattempt_allow ===0 && cmeDetailData.attempts.attempted === 0) ) ? 'filled' : 'filled-disabled'" class="btn-design medium ml-md-3"
                *ngIf="callon==undefined && cmeDetailData?.remark == 'not_attempted'"  (click)="attemptCme()"
                [eventTracker]='{"category":mls.googleEventText.cme_details.category,"action":mls.googleEventText.cme_details.key3,"product_type":"8", "product_id":cmeDetailData?.course_id}'>
                <span>{{mls.languageText.cme_details.key4}}<span
                    *ngIf="mls?.is_lskey_display==1">(cme_details.key4)</span></span>
              </button>

              <button [ngClass]="cmeDetailData?.cme_type == Cme_Type.MODULE ? 'd-none' : cmeDetailData?.remark != 'passed' && ((cmeDetailData.is_reattempt_allow ===1 && cmeDetailData.attempts.attempted > 0) || (cmeDetailData.is_reattempt_allow ===0 && cmeDetailData.attempts.attempted === 0) ) ? 'outline' : 'outline-disabled' " class="btn-design medium pt-1 pb-1"
                *ngIf="callon==undefined && cmeDetailData?.remark == 'failed'" (click)="attemptCme()"
                [eventTracker]='{"category":mls.googleEventText.cme_details.category,"action":mls.googleEventText.cme_details.key4,"product_type":"8", "product_id":cmeDetailData?.course_id}'>
                <span>{{mls.languageText.cme_details.key5}}<span
                    *ngIf="mls?.is_lskey_display==1">(cme_details.key5)</span></span>
              </button>

              <button [ngClass]="{'d-none' : cmeDetailData?.cme_type == Cme_Type.MODULE}" class="btn-design medium outline"
                *ngIf="
                  callon==undefined
                  && cmeDetailData?.remark == 'passed'
                  && cmeDetailData.certificate !== 0"
                (click)="viewCertificate()"
                [eventTracker]='{"category":mls.googleEventText.cme_details.category,"action":mls.googleEventText.cme_details.key5,"product_type":"8", "product_id":cmeDetailData?.course_id}'>
                <span>{{mls.languageText.cme_details.key6}}<span
                    *ngIf="mls?.is_lskey_display==1">(cme_details.key6)</span></span>
              </button>
              <!-- Download certificate button -->
              <button [ngClass]="{'d-none' : cmeDetailData?.cme_type == Cme_Type.MODULE}"
              class="btn-design medium filled download-btn ml-xs-0 ml-sm-0 ml-md-2 ml-lg-2" 
                *ngIf="
                  cmeDetailData?.certificate !== 0
                  && cmeDetailData?.remark == 'passed'
                  && cmeDetailData?.certificate_url!='' && cmeDetailData?.certificate_url!=undefined">
                <a class="text-white" href={{cmeDetailData?.certificate_url}} download target="_blank">
                  <img class="pr-2" src="assets/themes/icons/download-white.svg" alt="download"/>
                {{mls.languageText.cme_details.key17}}
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span *ngIf="cmeDetailData?.media.length >= 1">
    <div *ngIf=" !(cmeDetailData?.media?.length == 1 && cmeDetailData?.media[0]?.is_default == 1)" 
        [ngClass]="{'bg-white media-container rounded-corners-12': callon==undefined, 'p-4 btm-border': callon == 'modal' }">
      <div>
        <h4 class="heading-4">{{mls.languageText.cme_details.key7}}<span
            *ngIf="mls?.is_lskey_display==1">(cme_details.key7)</span></h4>
      </div>
      <div class="pt-3 custom-mdb-carousel rounded-bottom-2">
        <mdb-carousel tabindex="1" [activeSlideIndex]="mediaIdx" id="feed_modal_slider" class="carousel slide h-100"
          [animation]="'slide'" [isControls]="true" [interval]="0" [keyboard]="true">
          <mdb-carousel-item>
            <div class="row">
              <ng-container *ngFor="let Ml of cmeDetailData?.media; let indx=index;let odd = odd">
                <div class="my-1 pr-0" *ngIf="!Ml?.is_default" [ngClass]="{'col-4 col-sm-6': callon==undefined, 'col-12 col-sm-6': callon=='modal', 'pl-sm-2': callon=='modal' && odd}">
                  <span *ngIf="Ml?.file_type=='video'" 
                    class="position-relative" 
                    (click)="setResetMediaModal(true,indx);"
                    [eventTracker]='{"category":mls.googleEventText.cme_details.category,"action":mls.googleEventText.cme_details.key6,"product_type":"8", "product_id":cmeDetailData?.course_id}'>
                    <img class="position-absolute cursor-pointer cover-image preview-img"
                      src="assets/themes/icons/play-icon-bg.svg" />
                    <img class="position-absolute cursor-pointer toast-center-center toast-icon-size"
                      src="assets/themes/icons/play-icon.svg" />
                    <img class="cursor-pointer rounded-corners-12 preview-img" 
                      src={{Ml?.preview_url}} 
                      alt="preview"/>
                  </span>
                  <span *ngIf="Ml?.file_type=='image'">
                    <img class="cursor-pointer rounded-corners-12 preview-img" 
                      (click)="setResetMediaModal(true,indx);"
                      [eventTracker]='{"category":mls.googleEventText.cme_details.category,"action":mls.googleEventText.cme_details.key6,"product_type":"8", "product_id":cmeDetailData?.course_id}'
                      src={{Ml?.file_url}} />
                  </span>
                  <span *ngIf="Ml?.file_type=='document'" 
                    class="position-relative" 
                    (click)="setResetMediaModal(true,indx);"
                    [eventTracker]='{"category":mls.googleEventText.cme_details.category,"action":mls.googleEventText.cme_details.key6,"product_type":"", "product_id":""}'>
                    <img class="position-absolute cursor-pointer toast-center-center toast-icon preview-img"
                      src="assets/images/grandround/pdf.svg" />
                    <img class="cursor-pointer rounded-corners-12 preview-img" 
                      src={{Ml?.preview_url}}
                      onerror="this.src='assets/themes/images/banner-placeholder-lg.svg'" />
                  </span>
                </div>
              </ng-container>
            </div>
          </mdb-carousel-item>
        </mdb-carousel>
      </div>
    </div>
    </span>
    <!--Loaders-->
    <div *ngIf="!finishedDesc && masterService.isOnline==true" class='text-center'>
      <img src="assets/images/primary-loader.gif" width="40"  id="load icon">
    </div>
    <!--EOf Loaders-->

    <div [ngClass]="{'bg-white rounded-corners-12 mt-4 other-detail-container': callon==undefined, 'p-4 ': callon == 'modal','d-none' : cmeDetailData?.cme_type == Cme_Type.MODULE }"
      *ngIf="finishedDesc && masterService.isOnline==true &&  descDontshow !=true && cmeDetailDesc !=null ">
      <div>
        <h4 class="heading-4 pb-4"><span class="color-grey-700">{{cmeDetailData?.course_name}}</span></h4>
      </div>
      <div class="pb-1 new-inner-html">
        <div [innerHTML]="cmeDetailDesc?.cme_desc"></div>
      </div>
    </div>
  </div>



<!-- modal -->
<app-product-subscribe 
  *ngIf="showSubscribeModal"
  (resetSubscribeModal)="resetSubscribeModal() "
  (hasSubscribed)="hasSubscribed()"
  (backClicked)="subbackClicked() "
  [showSubscribeModal]="showSubscribeModal "
  [channelData]="subscribe_obj">
</app-product-subscribe>

<!--EOF Calling Media PopUp Component-->
<app-media-modal 
  *ngIf="mediaModal==true && openMediaIndex!=undefined" 
  (resetMediaModal)="setResetMediaModal($event)"
  [isMediaModalShown]="mediaModal" 
  [mediaObj]="mediaObj" 
  [openMediaIndex]="openMediaIndex" 
  [pType]="pType.CME">
</app-media-modal>

<!-- certificate -->
<app-media-modal 
  *ngIf="certificateMediaModal==true && openMediaIndex!=undefined"
  (resetMediaModal)="setResetCertificateModal($event)" 
  [isMediaModalShown]="certificateMediaModal"
  [mediaObj]="certificateMediaObj" 
  [openMediaIndex]="openMediaIndex" 
  [pType]="pType.CME">
</app-media-modal>

<!-- information message popup start-->
<app-action-modal 
  *ngIf="isActionModalShown==true" 
  (resetActionModal)="resetActionModal($event) "
  [isActionModalShown]="isActionModalShown" 
  [actionData]="actionData">
</app-action-modal>
<!-- information message popup -->

<app-action-pop-up
[confirmPopup]="lockedContentPopup.togglePopup"
[inputClass]="'course_details'"
class="course_details">
<ng-container *ngIf="lockedContentPopup.togglePopup && lockedContentPopup?.popupDetails != null">
  <div class="modal-body py-4 px-0">
    <div class="row py-2">
      <div class="col-12 text-center mt-4">

        <p class="heading-4  mt-2 mb-4">
          <img src="assets/images/Locked_big.svg" alt="locked content">
        </p>
        <p class="heading-4 fnt-weight500 color-black px-5">
          {{lockedContentPopup?.popupDetails?.title}}
        </p>
      </div>
    </div>
  </div>
  <div class="modal-footer px-3 text-center pb-4">
    <button class="btn-design filled large w-100" (click)="redirectToParentModule(lockedContentPopup)">
      {{lockedContentPopup?.popupDetails?.target?.button?.title}}
    </button>
  </div>
</ng-container>
</app-action-pop-up>
